import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Services from "./components/Services";
import Contact from "./components/Contact";
import ResourceHub from "./components/ResourceHub";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import "./App.css";

function App() {
  return (
    <div className="App bg-white">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Contact />
        <ResourceHub />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
